import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS, HTTP_VERBS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useUpdateDiscount = id => {
  const path = `${API_ENDPOINTS.DISCOUNTS}/${id}`;
  const { t } = useTranslation(LOCALIZATION_PAGES.DISCOUNTS);
  const { showNotification } = useRoot();
  const [{ result, loading, error }, updateDiscount] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('update_discount_fail'),
        },

        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('update_discount_success'),
      });
    }
  }, [result, showNotification, t]);

  return [{ result, loading }, updateDiscount];
};

export default useUpdateDiscount;
